import { combineReducers } from 'redux';
import browseProducts from './browseProducts';
import productDetails from './productDetails';
import productCategory from './productCategory';
import productListing from './productListing';
import productFilters from './productFilters';
import productFilterOptions from './productFilterOptions';
import skuTracker from './skuTracker';
import productRestrictions from './productRestrictions';

const productsModule = combineReducers({
  browseProducts,
  productDetails,
  productCategory,
  productListing,
  productFilters,
  productFilterOptions,
  skuTracker,
  productRestrictions,
});

export default productsModule;
